import React from 'react';
export default function amountFormatter(number){
    const formatter = new Intl.NumberFormat('en-US');
    return formatter.format(number);
}
